module.exports = __webpack_public_path__ + "static/media/images_section_img3.e3bd68bf.png";